import { combineReducers } from 'redux';
import currentUser from './current-user';

export default combineReducers({
  currentUser,
});
